import { render, staticRenderFns } from "./AccountUploadComp.vue?vue&type=template&id=c5dd2af6&scoped=true"
import script from "./AccountUploadComp.vue?vue&type=script&lang=js"
export * from "./AccountUploadComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dd2af6",
  null
  
)

export default component.exports